import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { useLocation } from 'react-router'

import { AppState } from 'store'
import { allPageStepsModes} from './pageSteps'
import { AppLinks } from 'enviroment/AppLinks'
import FullOffertInfoMenu from 'components/FullOffertInfoMenu/FullOffertInfoMenu'
import { FULL_OFFERT_MENU_TYPES } from 'components/FullOffertInfoMenu/FullOffertInfoMenuProps'
import useIsMobile from 'common/hooks/useIsMobile'
import { IPageStepperProps, NavbarProps } from './NavbarProps'

import PaykaLogo from 'assets/icons/payka-logo.svg'
import './NavbarStyles.scss'


const PageStepper = (props: IPageStepperProps) => {
   const { currentPageStepperMode, currentPageStepperStatus, currentPathName } = props

   const pagesWithStepper = [
      AppLinks.basicInfoForm, 
      AppLinks.addressInfoForm, 
      AppLinks.extendedInfoForm, 
      AppLinks.bmverify, 
      AppLinks.contractSigning,
      AppLinks.retention,
      AppLinks.mObywatelExtendedInfoForm,
      AppLinks.chooseIdentityMethod,
      AppLinks.chooseVerificationMethod,
      AppLinks.mObywatelIdentityMethod,
      AppLinks.mObywatelVerificationMethod,
      AppLinks.clientPeselReservedPage,
      AppLinks.videoVerificationBasicInfoForm,
      AppLinks.videoVerificationAddressInfoForm,
      AppLinks.videoVerificationVerificationErrorPage,
      AppLinks.videoVerificationIdentificationErrorPage,
      AppLinks.videoVerificationStartIdentificationPage,
      AppLinks.videoVerificationStartVerificationPage,
      AppLinks.trastiCollectPersonalIdForm
   ]

   if(pagesWithStepper.includes(currentPathName)){ // Steppera pokazujemy tylko na stronach na których zakłada to projekt
      return (
         <div className='page-stepper-outer-wrapper'>
            <div className='page-stepper-inner-wrapper'>
               {
                  Object.values(allPageStepsModes[currentPageStepperMode])
                  .map((step, index) => {
                     const isStepCurrentStep = step.name === currentPageStepperStatus.currentStep
                     const isStepActiveStep = currentPageStepperStatus.activeSteps.some(activeStep => activeStep.name === step.name)
   
                     return (
                        <div key={index} className={clsx('page-stepper-step', isStepCurrentStep && 'page-stepper-current-step', isStepActiveStep && 'page-stepper-step-active')} >
                           <p className='page-stepper-step-label'>{step.label}</p>
                           <div className='page-stepper-step-icon'/>
                        </div>
                     )
                  })
               }
            </div>
         </div>
      )
   }
   else {
      return null
   }   
}

const Navbar = (props: NavbarProps) => {
   const location = useLocation()
   const applicationState = useSelector((state: AppState) => state.applicationState)
   const isMobileDevice = useIsMobile()

   if(!props.showNavbar){
      return null
   }

   return (
      <header className='navbar-outer-wrapper'>
         <div className='navbar-inner-wrapper'>
            <div className='navbar-page-icon-wrapper'>
               <div className='navbar-page-icon'>
                  <img src={PaykaLogo} alt="logo" />
               </div>
               {isMobileDevice && 
                  <FullOffertInfoMenu 
                     menuType={FULL_OFFERT_MENU_TYPES.WALLET} 
                     isNavbarWalletMenu={true} 
                     className='navbar-summary-icon' 
                     workflowId={applicationState.workflowId} 
                  />
               }
            </div>
         </div>
         <PageStepper 
            currentPageStepperMode={applicationState.currentPageStepperMode}
            currentPathName={location.pathname}
            currentPageStepperStatus={applicationState.currentPageStepperStatus}
         />
      </header>
   )
}

export default Navbar
